// frontend/src/components/games/GameCompleteModal.tsx

interface GameCompleteModalProps {
  emoji?: string;
  title?: string;
  message?: string;
  xpEarned?: number;
  onPlayAgain: () => void;
  onReturnToCenter: () => void;
}

export function GameCompleteModal({
  emoji = '🏆',
  title = '🎉 Tebrikler!',
  message = 'Tüm eşleşmeleri tamamladın!',
  xpEarned,
  onPlayAgain,
  onReturnToCenter,
}: GameCompleteModalProps) {
  return (
    <div className="game-modal-overlay">
      <div className="game-modal-box">
        <div className="game-modal-emoji">{emoji}</div>
        <h2>{title}</h2>
        <p>{message}</p>
        {typeof xpEarned === 'number' && xpEarned > 0 && (
          <div className="game-modal-xp">+{xpEarned} XP</div>
        )}
        <div className="game-modal-actions">
          <button type="button" className="game-card-btn primary" onClick={onPlayAgain}>
            🔁 Tekrar Oyna
          </button>
          <button type="button" className="game-card-btn secondary" onClick={onReturnToCenter}>
            🎮 Oyun Merkezine Dön
          </button>
        </div>
      </div>
    </div>
  );
}
